<template>
  <div class="content">
    <van-loading type="spinner" v-if="nodata"/>
    <div class="about" :style="{ justifyContent: dominItem.templateId === 'temp3' ? 'flex-end' : ''}" >
      <div>
        <span>{{ nowDate }}</span>
        <span @click="changeType(1)" style="margin: 0 20px">{{ $t('con_home') }}</span>
        <span @click="changeType(1)">{{ $t('con_about') }}</span>
      </div>
    </div>
    <div class="logo" v-if="dominItem.templateId !== 'temp2'"
         :style="{ padding: dominItem.templateId === 'temp3' ? '0' : ''}" >
      <span v-if="dominItem.templateId !== 'temp3'">{{ dominItem.logoName || 'Logo' }}</span>
<!--      <img v-if="dominItem.nationId ==='jp'" :style="{ width: dominItem.templateId === 'temp3' ? '100%' : ''}" src="http://www.tokushima-ken.com/wp-content/uploads/sites/19/2020/11/ad.jpg" alt="">-->
    </div>
    <div class="logo" v-if="dominItem.templateId === 'temp2'">
      <img v-if="dominItem.nationId ==='jp'" src="http://www.tokushima-ken.com/wp-content/uploads/sites/19/2020/11/ad.jpg" alt="">
      <span style="display: block;  width: 100%">{{ dominItem.logoName || 'Logo' }}</span>
    </div>
    <div class="category" :class="[dominItem.templateId === 'temp2' ? 'categtemp2' : '']">
      <span  v-if="dominItem.templateId === 'temp3'" style="font-size: 25px;font-weight: bold; background: transparent">{{ dominItem.logoName || 'Logo' }}</span>
        <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
            item.label
          }}</span>
    </div>
    <div style="padding: 0 10%">
      <div class="content-hot" v-if="bestInfo">
        <div class="hot"> {{ $t('con_bestnew') }}</div>
        <div class="img-Box">
          <div style="text-align: center;">
          <img @click="toDetail(bestInfo.articleShortName)" :src="bestInfo.articleImage || defaultImg" alt="">
          </div>
            <div class="title-box" @click="toDetail(bestInfo.articleShortName)">
            <h2 class="title" @click="toDetail(bestInfo.articleShortName)">
              {{ bestInfo.articleTitle }}
            </h2>
            <div class="post-meta">
<!--              <span class="country">{{ $t('con_time') }}</span>-->
<!--              <span>{{ // bestInfo.uploadTime }}</span>-->
              <span style="margin: 0 20px; color: #ffffff" class="see-number">{{$t('con_see')}}</span>
              <span class="number">{{ bestInfo.articleReadNum }}</span>
            </div>
          </div>
        </div>


        <div class="post-list">
          <div v-for="(item, index) in articleList" class="post-list-box">
            <template v-if="index < 4">
              <div class="bot-img">
                <img @click="toDetail(item.articleShortName)" :src="item.articleImage || defaultImg" alt="">
              </div>
              <div style="padding: 10px 20px 20px">
                <span class="title" @click="toDetail(item.articleShortName)">{{ item.articleTitle }}</span>
                <div class="time">
<!--                  <span class="country">{{ $t('con_time') }}</span>-->
<!--                  <span>{{ item.uploadTime }}</span>-->
                  <span style="margin: 0 20px" class="see-number">{{$t('con_see')}}</span>
                  <span class="number">{{ item.articleReadNum }}</span>

                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>


    <div class="last-news">
      <!--          -->
      <div class="hot hot-new">{{ $t('con_latest') }}</div>

      <div class="last-news-content">
        <div v-for="item in latestNewsList"
             style="display: flex; justify-content: space-between;background: #ffffff;margin-bottom: 30px">
          <div class="imgbox">
            <img :src="item.articleImage || defaultImg" alt="">
          </div>
          <div class="last-news-content-box">
            <span  class="articleIntro" style="margin-top: 10px">{{ item.articleTitle }}</span>
            <div class="time">
<!--              <span class="country">{{ $t('con_time') }}</span>-->
<!--              <span>{{ item.uploadTime }}</span>-->
              <span style="margin: 0 20px" class="see-number">{{$t('con_see')}}</span>
              <span class="number">{{ item.articleReadNum }}</span>

            </div>
            <span class="articleIntro" style="margin: 10px 0; font-size: 16px;color: #4a4a4a">{{ item.articleIntro }}</span>
            <div class="readmore" @click="toDetail(item.articleShortName)">
              {{ $t('con_read_more') }}
              <!--                READ MORE...-->
            </div>
          </div>
        </div>
      </div>
      <van-pagination
          v-model="newsPageNum"
          :total-items="newsTotal"
          @change="getLatestNewsList"
          :items-per-page="5"
          :prev-text="$t('con_PREV')"
          :next-text="$t('con_NEXT')"
          :show-page-size="5"
          force-ellipses
      />
    </div>

    <div class="last-news cat-news" style="background: #F9F9F9">
      <div class="hot hot-new">{{ $t('con_recommend') }}</div>
      <div class="last-news-content">
        <div v-for="item in recommendList" class="content-box" @click="toDetail(item.articleShortName)">
          <div class="bot-img">
            <img :src="item.articleImage || defaultImg" alt="">
          </div>
          <div style="padding: 0 20px 20px">
            <div class="last-news-content-box">
              <span class="title" style="margin-top: 10px; font-size: 15px">{{ item.articleTitle }}</span>
            </div>
            <div class="time">
<!--              <span class="country">{{ $t('con_time') }}</span>-->
<!--              <span>{{ item.uploadTime }}</span>-->
              <span style="margin: 0 20px" class="see-number">{{$t('con_see')}}</span>
              <span class="number">{{ item.articleReadNum }}</span>
            </div>
          </div>
        </div>
      </div>
      <van-pagination
          v-model="recommendPageNum"
          :total-items="recommendTotal"
          @change="getRecommendList"
          :items-per-page="6"
          :prev-text="$t('con_PREV')"
          :next-text="$t('con_NEXT')"
          :show-page-size="5"
          force-ellipses
      />
    </div>

    <div class="footer">
      <span style="font-size: 50px">{{ dominItem.logoName || 'Logo' }}</span>
      <div class="icon-box"  v-if="dominItem.nationId !== 'cn'">
        <div v-for="item in iconList" @click="openLink(item.link)" >
          <img :src="item.url" alt="">
        </div>
      </div>
      <div class="category foot-cate">
        <span v-for="item in typeList" @click="changeType(item.id)">{{ item.label }}</span>
      </div>
      <span>© 2023 - {{ dominItem.logoName || 'Logo' }}. All Rights Reserved. Website: {{ dominItem.logoName || 'Logo' }}</span>
    </div>

  </div>
</template>
<script>
import {getContentList, getLatestNews, getRecommend, getOne, getDomainName} from "@/api/index"
import {format} from 'date-fns'
import Clipboard from 'clipboard';
import {Toast} from 'vant';

export default {
  props: {
    dominItem: Object
  },
  data() {
    return {
      current: 1,
      defaultImg: undefined,
      clipboardText: window.location.href,
      currentPage: 1,
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7}],
      articleList: [],
      latestNewsList: [],
      recommendList: [],
      newsPageNum: 1,
      newsTotal: undefined,
      recommendPageNum: 1,
      recommendTotal: undefined,
      bestInfo: undefined,
      nodata: false,
      iconList: [
        {url: require('../../assets/icon1.svg'), link: 'https://www.facebook.com/'},
        {url: require('../../assets/icon2.svg'), link: 'https://twitter.com/'},
        {url: require('../../assets/icon3.svg'), link: 'https://www.google.com/'},
        {url: require('../../assets/icon4.svg'), link: 'https://www.instagram.com/'},
        {url: require('../../assets/icon5.svg'), link: 'mailto:#'},
        {url: require('../../assets/icon6.svg'), link: 'https://www.youtube.com/'},
      ],

    };
  },

  created() {
    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    }else {
      this.getArticleList()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getOneList()
    }
    this.defaultImg = JSON.parse(localStorage.getItem('dominItem')).defaultImg

    this.nowDate = format(new Date(),  this.$t('con_format'))
  },

  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getOneList()
    },
    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        this.bestInfo = res.data
        this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },

    // 获取文章列表
    getArticleList() {
      this.nodata = true
      getContentList({articleCategoryId: this.current,articleNationId: this.dominItem.nationId}).then(res => {
        this.articleList = res.rows
        this.nodata = false
        this.articleList.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        })
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList() {
      getLatestNews({articleCategoryId: this.current, pageNum: this.newsPageNum, pageSize: 5, articleNationId: this.dominItem.nationId}).then(res => {
        this.latestNewsList = res.rows
        this.newsTotal = res.total
        this.latestNewsList.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        })
      })
    },

    //  获取推荐的文章
    getRecommendList() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 6, articleNationId: this.dominItem.nationId}).then(res => {
        this.recommendList = res.rows
        this.recommendTotal = res.total
        this.recommendList.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        })
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  },
};
</script>
<style lang="scss" scoped>
@import "jp";
</style>
